export default "dist/images/block-header-plain.1630c7e.png";